/* Opt-in, preference-consented browser history only. No analytics endpoint. */
class OccRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.key = 'occ_recent_v2'; this.optKey = 'occ_recent_v2_enabled';
    this.enable = this.querySelector('[data-enable]'); this.clear = this.querySelector('[data-clear]');
    this.message = this.querySelector('[role="status"]'); this.grid = this.querySelector('[data-grid]');
    this.events = new AbortController();
    this.enable.addEventListener('click', () => this.activate(), {signal:this.events.signal});
    this.clear.addEventListener('click', () => this.forget(), {signal:this.events.signal});
    document.addEventListener('visitorConsentCollected', () => this.update(), {signal:this.events.signal});
    await this.privacyReady(); await this.update();
  }
  disconnectedCallback() { this.events?.abort(); this.ready = false; this.generation = (this.generation || 0) + 1; }
  privacyReady() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve();
    return new Promise(resolve => {
      const timer = setTimeout(resolve, 2500);
      window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], () => {clearTimeout(timer);resolve();});
    });
  }
  allowed() { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
  async activate() {
    await this.privacyReady();
    if (!this.allowed()) { this.message.textContent = 'Please allow preferences in your privacy settings, then try again. No browsing history has been saved by this feature.'; return; }
    try { localStorage.setItem(this.optKey, 'yes'); } catch (_) { this.message.textContent = 'Browser storage is unavailable. You can keep shopping without this feature.'; return; }
    await this.update();
  }
  forget() {
    this.generation = (this.generation || 0) + 1;
    try { localStorage.removeItem(this.key); localStorage.removeItem(this.optKey); } catch (_) { /* storage unavailable */ }
    this.grid.replaceChildren(); this.enable.hidden = false; this.clear.hidden = true;
    this.message.textContent = 'History cleared. Products will not be remembered until you enable this again.';
  }
  async update() {
    if (!this.allowed()) { this.forget(); this.message.textContent = 'Optional: remember products on this browser. No account or cross-device tracking.'; return; }
    let handles = [], enabled = false;
    try { enabled = localStorage.getItem(this.optKey) === 'yes'; handles = JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (_) { return; }
    if (!enabled) return;
    this.enable.hidden = true; this.clear.hidden = false;
    handles = Array.isArray(handles) ? handles.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)) : [];
    if (this.dataset.current) handles = [this.dataset.current, ...handles.filter(h => h !== this.dataset.current)];
    handles = [...new Set(handles)].slice(0,12);
    try { localStorage.setItem(this.key, JSON.stringify(handles)); } catch (_) { return; }
    const generation = this.generation = (this.generation || 0) + 1;
    const others = handles.filter(h => h !== this.dataset.current).slice(0, Number(this.dataset.limit) || 4);
    const products = await Promise.all(others.map(async handle => {
      try { const response = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js'); return response.ok ? await response.json() : null; } catch (_) { return null; }
    }));
    if (generation !== this.generation || !this.isConnected || !this.allowed()) return;
    this.grid.replaceChildren();
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-ZA', {style:'currency',currency:window.Shopify?.currency?.active || this.dataset.currency}).format(cents / 100);
    products.filter(Boolean).forEach(product => {
      const item = document.createElement('li'), link = document.createElement('a');
      link.className = 'occ-recent__card'; link.href = product.url;
      const media = document.createElement('span'); media.className = 'occ-recent__media';
      if (product.featured_image) {
        const img = document.createElement('img'); const src = new URL(product.featured_image, location.origin); src.searchParams.set('width','600');
        img.src = src.href; img.alt = product.title; img.width = 600; img.height = 750; img.loading = 'lazy'; media.append(img);
      }
      const title = document.createElement('h3'); title.className = 'occ-recent__title'; title.textContent = product.title;
      const price = document.createElement('p'); price.className = 'occ-recent__price'; price.textContent = (product.price_varies ? 'From ' : '') + money(product.price) + (product.available ? '' : ' · Sold out');
      link.append(media,title,price); item.append(link); this.grid.append(item);
    });
    this.message.textContent = this.grid.children.length ? 'Recently viewed on this browser. Prices and availability refreshed now.' : 'Enabled. View some products, then come back here to pick up where you left off.';
  }
}
if (!customElements.get('occ-recently-viewed')) customElements.define('occ-recently-viewed', OccRecentlyViewed);
